// l10n status: partial
import { flow /*, observable, computed, action */ } from "mobx"
import { TraxisCpeIdMixin } from "store/api/mixin/TraxisCpeIdMixin"
// MTVW-585: 1 retry
import { fetchWithRetry, DEFAULT_RETRIES, DEFAULT_TIMEOUT, NO_RETRIES } from "./FetchWithRetry"
import { serviceUrls } from "store/qlapi/ServiceUrls"
import { getQlHeaders } from "store/qlapi/QlHeaders"
import { isFairPlaySupported, isWidevineSupported } from "utils/Utils"
import { ErrorBase } from "store/ErrorBase"
import { MicroServiceError } from "./MicroServiceError"
import { GenericError } from "store/GenericError"
import { appFeatures } from "../../AppFeatures"
// TODO: Remove, temporary for DRM PoC
import { rootStore } from "store/RootStore"
import { getCpeId } from "store/api/mixin/TraxisCpeIdMixin"
import { getUrlQueryParam } from "utils/Utils"
import { moment } from "store/util/moment"
import { TIME_FORMAT_BACKEND } from "store/model/Time"
import { l10n } from "store/lang/L10n"

import { getCoCoModule, CoCoError } from "store/page/repo/CoCoModule"
const CoCo = await getCoCoModule()


// MTV-3570: Moved to ServiceUrls
/*
export const BASE_URL_PROD = "https://content.quickline.ch/media/v008/"
//export const BASE_URL_PROD = "https://services-sg0.qltv.quickline.ch/media/v008/"
export const BASE_URL_STAGE = "https://content.stage.quickline.ch/media/v008/"
*/

// MTVW-577: provide cookie
const CREDENTIALS = 'include'
const STD_HEADERS = {
	'Accept': 'application/json',
	// Would cause CORS in keepAlive
	//'pragma': 'no-cache', 'cache-control': 'no-cache'
}

export class MediaService extends TraxisCpeIdMixin {

	get xHeaders() {
		// make a copy of STD_HEADERS, otherwise STD_HEADERS would be changed!
		const headers = {}
		Object.assign(headers, STD_HEADERS)
		Object.assign(headers, getQlHeaders())
		return headers
	}

	version = flow(function* () {
		let resultJson = yield CoCo.apiFetchMediaVersionRaw()
		// CoCo returns string instead of object, need to convert to object
		if (typeof resultJson === "string") resultJson = JSON.parse(resultJson)
		return `${resultJson["build_tag"]} (${resultJson["build_date"]})`
	})

	versionUrl() {
		return [serviceUrls.mediaUrl + "version", this.xHeaders]
	}

	// MTVW-682
	_checkForExistingManifest = flow(function* (manifestUrl, retryCount = DEFAULT_RETRIES) {
		const config = {
			url: manifestUrl,
			fetchOptions: {
				method: 'GET',
				headers: this.xHeaders,
				//credentials: CREDENTIALS,
			},
			retryCount: retryCount,
			timeout: DEFAULT_TIMEOUT,
			codes: ["MediaService _checkForExistingManifest"],
			service: "MediaService",
			createException: true,
			displayError: false,
			noJsonResponse: true
		}

		// eslint-disable-next-line no-unused-vars
		try {
			const [response, resultJson, requestId, error] = yield fetchWithRetry(config)
		}
		catch (e) {
			console.error("_checkForExistingManifest error", e)
			const error = ErrorBase.CreateError(["Manifest: " + e?.e], null, { code: "404?", type: "error.type" })
			rootStore.page.Player.error = error
			throw error
			return //throw error
		}
		//console.debug("_checkForExistingManifest", manifestUrl, response)
	})

	// UNUSED, would not work
	/*
	parseComplexError(errStr) {
		try {
				// 1. Extract just the content between Some(" and ")
				const startIdx = errStr.indexOf('Some("') + 6;
				const endIdx = errStr.lastIndexOf('")');
				let innerContent = errStr.substring(startIdx, endIdx);
	
				// 2. Fix the "Bad Escaped Character" error
				// The logger escaped quotes as \\" and newlines as \\n.
				// We need to turn \\" back into " so JSON.parse understands it.
				const sanitized = innerContent
					.replace(/\\"/g, '"')    // Convert \" to "
					.replace(/\\\\n/g, '\n') // Convert \\n to \n
					.replace(/\\n/g, '\n');  // Convert remaining \n
	
				console.debug("unescaped", sanitized)
				//const unescaped = JSON.parse(`"${sanitized}"`)
				const parsed = JSON.parse(innerContent)
				return JSON.parse(innerContent);
		} catch (e) {
				console.error("Parsing failed at:", e.message);
				return null;
		}
	}
	*/

	handleCoCoError(e) {
		// throw is caught in Player.handlePlaySourceAsync
		throw new CoCoError(e)
		/*
		const underlyingError = e?.underlyingError()
		//console.debug("handleCoCoError", e, underlyingError, typeof underlyingError)
		let error = null
		if (typeof underlyingError === "string") {
			// CoCo error
			const result = JSON.parse(underlyingError).MicroserviceError
			//console.debug("CoCo error result", result)
			// MTVW-1129: prevent crash when result is not set
			if (result) {
				const requestId = result.request_id
				const statusCode = result.status_code
				const payload = JSON.parse(result.payload)
				if (payload) {
					error = MicroServiceError.tryCreateErrorFromJson(["MediaService setupStreamAsync"], {} payload, `Request failed with status ${payload?.status}`, requestId, "error")
					throw error
				}
			}
		}
		throw e
		*/
	}

	_getDrmSchemeAsync = flow(function* (channelId, type) {
		const hasFairplaySupport = yield isFairPlaySupported()
		const hasWidevineSupport = yield isWidevineSupported()

		let drmScheme = null
		if (hasWidevineSupport) drmScheme = "widevine"
		else if (hasFairplaySupport) drmScheme = "fairplay"
		const channel = rootStore.channelsService.getChannel(channelId)
		console.debug("_getDrmSchemeAsync type %s channel %s, encrypted %s", type, channelId, channel?.isEncrypted)
		// MTVW-927
		if (!drmScheme && channel?.isEncrypted) {
			const error = new GenericError(l10n.featurePlayerErrorNoPlaybackTitle,
				l10n.featurePlayerErrorNoDrmMessage.replaceAll("\\n", "\n"))
			if (!rootStore.page.Player.error) rootStore.page.Player.error = error
			return //throw error
		}
		return drmScheme
	})

	setupLiveStreamAsync = flow(function* (channelId) {
		const drmScheme = yield this._getDrmSchemeAsync(channelId, "live")
		let streamInfo = null
		try {
			streamInfo = yield CoCo.apiFetchLiveStream(channelId, drmScheme, appFeatures.persistedNtl, null /*x_quickline_hint only on STB */)
			// test
			//yield this._checkForExistingManifest(streamInfo?.streamUrl.replace("/GlobalManifest", "xxx/GlobalManifest"))
			yield this._checkForExistingManifest(streamInfo?.streamUrl)
		}
		catch (e) {
			this.handleCoCoError(e)
		}
		return streamInfo
	})

	setupReplayStreamAsync = flow(function* (channelId, startTime, endTime) {
		//const cookie = JSON.parse(rootStore.sso.getBase64Cookie("nxr-cookie") || "{}")
		//console.debug("cookie", cookie.device_id, cookie)
		const drmScheme = yield this._getDrmSchemeAsync(channelId, "replay")
		let streamInfo = null
		try {
			streamInfo = yield CoCo.apiFetchReplayStream(channelId, startTime, endTime, drmScheme, null /*precise_buffer*/, null /*trim_buffer*/, null /*x_quickline_hint only on STB */)
			// test
			//yield this._checkForExistingManifest(streamInfo?.streamUrl.replace("/GlobalManifest", "xxx/GlobalManifest"))
			yield this._checkForExistingManifest(streamInfo?.streamUrl)
		}
		catch (e) {
			this.handleCoCoError(e)
		}
		return streamInfo
	})

	setupRecordingStreamAsync = flow(function* (channelId, startTime, endTime, recordingId) {
		const drmScheme = yield this._getDrmSchemeAsync(channelId, "recording")
		let streamInfo = null
		try {
			streamInfo = yield CoCo.apiFetchRecordingStream(channelId, startTime, endTime, recordingId, drmScheme, null /*x_quickline_hint only on STB */)
			// test
			//yield this._checkForExistingManifest(streamInfo?.streamUrl.replace("/GlobalManifest", "xxx/GlobalManifest"))
			yield this._checkForExistingManifest(streamInfo?.streamUrl)
		}
		catch (e) {
			this.handleCoCoError(e)
		}

		// MTVW-794: DASH/Widevine test build for Divitel
		let overrideUrl = null
		overrideUrl = getUrlQueryParam("rec")
		if (overrideUrl) {
			console.debug("overrideUrl", overrideUrl)
			console.debug("keepAliveUrl", overrideUrl?.substring(0, overrideUrl?.indexOf("Global")) + "keepalive")
			streamInfo.streamUrl = overrideUrl
			streamInfo.keepAliveUrl = overrideUrl.substring(0, overrideUrl.indexOf("Global")) + "keepalive"
		}

		return streamInfo
	})

	// MTVW-633: retry 1, timeout 5000
	keepAliveFetch = flow(function* (url, timeout = 5000, retryCount = NO_RETRIES) {
		// called from within periodic timer setInterval, error would not be caught!
		const config = {
			url: url,
			fetchOptions: {
				method: 'GET',
				// X-Quickline headers would cause a CORS issue
				// MTVW-267: Do not include headers
				//headers: STD_HEADERS
				// MTVW-549
				headers: this.xHeaders,
				// MTVW-577: No cookie for keepalive on streamers
				//credentials: CREDENTIALS
			},
			retryCount: retryCount,
			timeout: timeout,
			codes: ["MediaService keepAlive"],
			service: "MediaService",
			// MTVW-980: do not create exception, event "playerError" will be handled
			createException: false,
			displayError: false
		}
		// eslint-disable-next-line no-unused-vars
		const [response, resultJson, requestId, error] = yield fetchWithRetry(config)
		//console.debug("rsp %o, exc %o", response, exception)
	})

	// throws "Unknown" exception FOLLOWED by "The browser has been put into sleep mode"
	keepAlive = flow(function* (url) {
		try {
			yield CoCo.apiKeepAliveMediaSession(url)
		}
		catch (e) {
			this.handleCoCoError(e)
		}
	})

	getSessions = flow(function* () {
		let sessions = null
		try {
			sessions = yield CoCo.fetchMediaSessions()
		}
		catch (e) {
			this.handleCoCoError(e)
		}
		//console.debug("getSessions CoCo", sessions?.[0].sessionId)
		return sessions
	})

	keepAliveDelegation = flow(function* (sessionId, enable) {
		let result = null
		try {
			result = yield CoCo.updateMediaSession(sessionId, enable)
		}
		catch (e) {
			this.handleCoCoError(e)
		}
		//console.debug("keepAliveDelegation CoCo", result)
		return result
	})

	deleteSession = flow(function* (sessionId) {
		let result = null
		try {
			result = yield CoCo.deleteMediaSession(sessionId)
		}
		catch (e) {
			debugger
			this.handleCoCoError(e)
		}
		console.debug("deleteSession CoCo", result)
		return result
	})

	getThumbnails = flow(function* (channelId, start, end, fetchStrategy = CoCo.FetchStrategy.CacheFirst) {
		try {
			// would return max. 360 thumbs with start somewhere in the middle of the window
			/*
			const test = yield CoCo.fetchThumbnails(channelId, BigInt(Math.round(start)), Math.round((end - start) / 10000), fetchStrategy)
			console.debug("test getThumbnails", start, Math.round((end - start) / 10000), test)
			*/
			let thumbs = { thumbs: [] }
			//console.debug("getThumbnails", channelId, moment(start).utc().format(TIME_FORMAT_BACKEND), moment(end).utc().format(TIME_FORMAT_BACKEND))
			if (appFeatures.showThumbnails) thumbs = yield CoCo.apiFetchThumbnails(channelId, moment(Math.round(start)).utc().format(TIME_FORMAT_BACKEND), moment(Math.round(end)).utc().format(TIME_FORMAT_BACKEND), fetchStrategy)
			//console.debug("thumbs=", thumbs)
			return thumbs
		}
		catch (e) {
			console.error("getThumbnails", e)
			return { thumbs: [] }
		}
	})
}
